const mediaItems = [
  {
    title: '《雷霆行动》幕后花絮',
    desc: '走进这部动作巨制的拍摄现场，揭秘惊险的追车戏与爆炸场面是如何完成的。',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20action%20movie%20filming%20with%20warm%20lighting%2C%20camera%20equipment%20and%20crew%20silhouettes%2C%20dramatic%20atmosphere%2C%20cinematic%20documentary%20style%2C%20rich%20amber%20tones&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '12:45',
  },
  {
    title: '经典电影修复技术揭秘',
    desc: '了解 4K 数字修复如何让老电影焕发新生，从胶片扫描到逐帧修复的全过程。',
    img: 'https://readdy.ai/api/search-image?query=Film%20restoration%20studio%20with%20vintage%20film%20reels%20and%20modern%20digital%20equipment%2C%20warm%20sepia%20and%20bronze%20lighting%2C%20technical%20atmosphere%2C%20cinematic%20documentary%20style&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '18:22',
  },
  {
    title: '2026 暑期档新片前瞻',
    desc: '抢先预览今夏最值得期待的新片阵容，从动作到喜剧一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Movie%20preview%20showcase%20with%20cinematic%20lighting%20and%20film%20poster%20collage%20elements%2C%20warm%20golden%20and%20amber%20highlights%2C%20dramatic%20spotlight%20effect%2C%20elegant%20composition&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '08:15',
  },
  {
    title: '资深影迷选片指南',
    desc: '如何在海量影片中快速找到适合自己的好电影？这份选片攻略请收好。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20cinema%20setup%20with%20warm%20ambient%20lighting%2C%20movie%20selection%20on%20screen%2C%20comfortable%20atmosphere%2C%20soft%20golden%20glow%2C%20cinematic%20lifestyle%20aesthetic&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '06:50',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精彩花絮
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            幕后故事、制作特辑与观影指南，发现电影之外的精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/75 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}